import { Box, font } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import { lerp } from '@lemonade-hq/ts-helpers';
import type React from 'react';
import styled, { css } from 'styled-components';
import { textRiseAnimation, textRiseAnimationMobile } from '../Giveback2020/Giveback2020Animations';

const Container = styled(Box)<{ delay: number }>`
  width: 100%;
  user-select: none;
  animation: ${textRiseAnimation} 1000ms 2.25s ease-out both;

  ${MEDIA_QUERIES.upToDesktop`
        animation: ${textRiseAnimationMobile} ${({ delay }: { delay: number }) => delay}ms 2.25s ease-out both;
    `}

  ${MEDIA_QUERIES.desktop`
        animation: ${textRiseAnimation} ${({ delay }: { delay: number }) => delay}ms 2.25s ease-out both;
    `};

  @media (prefers-reduced-motion) {
    animation-duration: 0ms !important;
    animation-delay: 0ms !important;
  }
`;

const smallStyle = css`
  letter-spacing: -1px;
  height: 230px;
  ${font('main', { fontSize: '46px', lineHeight: 1, fontWeight: 900 })};
`;

const largeStyle = css`
  letter-spacing: -4px;
  height: 650px;
  ${font('main', { fontSize: '130px', lineHeight: 1, fontWeight: 900 })};
`;

const MobileFirstTitle = styled(Box)`
  will-change: opacity;

  ${MEDIA_QUERIES.upToDesktop`
        ${smallStyle}
    `}

  ${MEDIA_QUERIES.desktop`
        ${largeStyle}
    `};
`;

const DesktopFirstTitle = styled(Box)`
  will-change: opacity;

  ${MEDIA_QUERIES.mobile`
        ${smallStyle}
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${largeStyle}
    `};
`;

const GivebackInitialTitle: React.FC<
  React.PropsWithChildren<{
    t?: number;
    mb: number[];
    delay?: number;
    desktopFirst?: boolean;
  }>
> = ({ t = 0, children, desktopFirst, delay = 1000, ...props }) => {
  const opacity = lerp(1, 0.1, t);

  const TitleComponent = desktopFirst ? DesktopFirstTitle : MobileFirstTitle;
  return (
    <Container delay={delay} {...props}>
      <TitleComponent desktopFirst={desktopFirst} style={{ opacity }}>
        {children}
      </TitleComponent>
    </Container>
  );
};

export default GivebackInitialTitle;
